import React from "react";

const ContainerWithVerticalLine = ({topLeft, bottomLeft, topRight, bottomRight, style}) => {
  return (
    <div style={{ display: "flex", width: "100%", ...style }}>
      <div style={{ display: "flex", width: "50%" }}>
        <div className={"pre-cog-assets-drawer-hr-vertical"} >&nbsp;</div>
        <div style={{ marginLeft: "10px",  display: "flex", flexDirection: "column", justifyContent: "space-between"  }}>
          {topLeft}
          {bottomLeft}
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
        {topRight}
        {bottomRight}
      </div>
    </div>
  );
};

export default ContainerWithVerticalLine;